import { render, staticRenderFns } from "./ModalInfoToConfirmPaymentBeam.vue?vue&type=template&id=2bbb9086&scoped=true&"
import script from "./ModalInfoToConfirmPaymentBeam.vue?vue&type=script&lang=ts&"
export * from "./ModalInfoToConfirmPaymentBeam.vue?vue&type=script&lang=ts&"
import style0 from "./ModalInfoToConfirmPaymentBeam.vue?vue&type=style&index=0&id=2bbb9086&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbb9086",
  null
  
)

export default component.exports